import { render, staticRenderFns } from "./RelatedProductBlock.vue?vue&type=template&id=7a4d628c&scoped=true&"
import script from "./RelatedProductBlock.vue?vue&type=script&lang=js&"
export * from "./RelatedProductBlock.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProductBlock.vue?vue&type=style&index=0&id=7a4d628c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4d628c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSwiperCarousel: require('/app/components/UI/UiSwiperCarousel.vue').default})
